import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import * as Tooltip from '@radix-ui/react-tooltip';
import { Toaster } from 'sonner';
import { createQueryClient } from '@/lib/queryClient';
import { AuthProvider } from '@/features/auth/AuthContext';
import { ThemeProvider } from './theme';

/**
 * Application providers.
 *
 * The router is **not** here: with a data router, `RouterProvider` is itself the root of
 * the route tree, so everything it needs must wrap it from outside. `AuthProvider` uses no
 * router hooks, so it sits here quite happily and is available to every guard and page
 * beneath the router.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Tooltip.Provider delayDuration={300}>
            {children}
            <Toaster position="top-right" richColors closeButton />
          </Tooltip.Provider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
